import axios from "axios";
import { toast } from "react-toastify";
export const GetAllLand = (data) => {
  return {
    type: "get_alllands",
    payload: data,
    loader: false,
  };
};
export function getallland() {
  return (dispatch) => {
    axios({
      url: `${process.env.REACT_APP_API_URL}Land/GetLand`,
      method: "Get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "content-type": "application/json",
      },
    }).then(
      (result) => {
        if (result.data.IsSuccess === true) {
          dispatch(GetAllLand(result.data.Data));
        } else {
          toast.info(result.data.Message);
        }
      },
      (error) => {
        toast.info("Something went wrong!");
      }
    );
  };
}

export const GetAllLandById = (data) => {
  return {
    type: "get_alllands_byid",
    payload: data,
    loader: false,
  };
};
export function getalllandbyId(id) {
  return (dispatch) => {
    axios({
      url: `${process.env.REACT_APP_API_URL}Land/GetLandById?LandPurchasedId=${id}`,
      method: "Get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "content-type": "application/json",
      },
    }).then(
      (result) => {
        if (result.data.IsSuccess === true) {
          dispatch(GetAllLandById(result.data));
        } else {
          toast.info(result.data.Message);
        }
      },
      (error) => {
        toast.info("Something went wrong!");
      }
    );
  };
}
